export default __webpack_public_path__ + "static/media/blog-3.73427ce6.jpg";